import React from "react";
import SubPageTemplate from "../../components/subpagetemplate";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";
import { useBrandOffers } from "../../hooks/useBrandOffers";
import {
  brandTitleFromRoute,
  brandTypeFromRoute,
  PARTNERBOOST_SOURCE,
} from "../../utils/partnerBoost";

const Brands: React.FC<{ category: string }> = ({ category }) => {
  const brandsData = useBrandOffers(category);
  const categoryTitle = brandTitleFromRoute(category);
  const brandType = brandTypeFromRoute(category);
  const seoMeta =
    category === "walmart" || category === "amazon"
      ? pageSeoConfig[category]
      : pageSeoConfig.dtc;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <SubPageTemplate
        standard_categories={brandsData}
        title={categoryTitle}
        detailLinkParams={
          brandType
            ? { source: PARTNERBOOST_SOURCE, brandType }
            : undefined
        }
      />
    </>
  );
};

export default Brands;
